import { ShowStatus } from "@quantizr-engineering/common/types/show";
import {
  formatCurrency,
  formatNumber,
  formatPercentage,
} from "../utils/numberFormatters";
import { getStatusStyling } from "../utils/showStatus";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

interface TakeHomeCardProps {
  label: string;
  amount: number;
  runScore: number | null | undefined;
  status?: "Potential" | "Projected" | "Forecasted" | "Actual";
  height?: string;
}

const bgColors = {
  ["Potential"]: "bg-[#E9E8ED] text-[#48455B]",
  ["Projected"]: "bg-[#F1E5FF] text-[#4932F5]",
  ["Forecasted"]:
    "bg-[linear-gradient(to_top_right,_var(--tw-gradient-stops))] from-custom-teal to-custom-dark-purple via-custom-purple",
  ["Actual"]: "bg-[#E2F4FC] text-[#0D5F7F]",
};

const textColors = {
  ["Potential"]: "text-[#48455B]",
  ["Projected"]: "text-[#4932F5]",
  ["Forecasted"]: "",
  ["Actual"]: "text-[#0D5F7F]",
};

const TakeHomeCard = ({
  label,
  amount,
  runScore,
  status = "Potential",
  height,
}: TakeHomeCardProps) => {
  const formatRunScore = () => {
    if (runScore === null || runScore === undefined || isNaN(runScore)) {
      return "-";
    }
    return formatPercentage(runScore);
  };

  return (
    <div
      className={`${bgColors[status]} p-6 object-contain ${
        height || "w-full h-full"
      }`}
    >
      <div className="card-body p-0 flex justify-between">
        {/* Header section */}
        <div className="flex flex-col">
          <span className="text-sm text-gray-700">{label}</span>
          <span className="text-3xl font-bold text-black">
            {formatCurrency(amount)}
          </span>
        </div>
        <div className="flex flex-col mt-4 space-between">
          <span className="text-sm text-gray-700">Run Score</span>

          <div className="flex w-full">
            <span className="text-2xl font-bold text-black my-1">
              {formatRunScore()}
            </span>
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-end">
        <label className={`text-lg font-medium ${textColors[status]}`}>
          <b>{status}</b>
        </label>
      </div>
    </div>
  );
};

export default TakeHomeCard;
